import { Grid } from '@mui/material'
import React, { useContext } from 'react'
import styles from './../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import IconsColor from '../../../../utility/iconsColor'
import globalStyles from '../../../../../assets/styles/global.module.scss'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext'
import { actionTypeObj, ChatbotStepActionData, ChatbotStepActionDataInterface, SaveVariableActionData, SendWADMTemplateActionData, SendWADMTextActionData, workFlowNode } from '../../../../../models/flowBuilderTypes'

import { isCurrentViewVersionPublished } from '../../utilityFunctions'
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext'
import { ACTION_TYPE_NAME, actionTypes, chatbot_step_type_id_basic, chatbot_step_type_id_webhook, getCurrentActiveNodeData, hasTalkToAgentAction } from '../../flowBuilderConstants'
import { greyColor } from '../../../../../utils/colors'
import { isWhatsAppChannel } from '../../../../../pages/ruleBasedInbox/channelConstants'

const NewContentBlocks = (props: any) => {
    
    const { onChangeCurrentActiveNodeConfig, nodes, edges, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload

    function isDisabled(actionTypeName: string, maxAllowedActions?: number) {

        const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;
        const isWhatsapp = isWhatsAppChannel(channelName);
            
        if (isCurrentViewVersionPublished(currentActiveStaticWorkflow)) {
            return true;
        }

        const data = currentActiveNodeConfig?.data && nodes?.find((node: workFlowNode) => node.id == currentActiveNodeConfig.nodeId)?.data;

        if (!Array.isArray(data)) {
            return false;
        }

        if (maxAllowedActions) {
            const lengthOfAction = data?.filter((action: ChatbotStepActionDataInterface) => action.action_type.action_type_name == actionTypeName).length;
            if (lengthOfAction >= maxAllowedActions) return true;
        }

        // Whatsapp specific actions
        if(isWhatsapp) {

            const talkToAgentActionExists = hasTalkToAgentAction(data);
            if (talkToAgentActionExists) return true;

            if (actionTypeName == ACTION_TYPE_NAME["TALK_TO_AGENT"]) {
                return data?.length > 0;
            }

            if(actionTypeName == ACTION_TYPE_NAME["ARCHIVE_CHAT"]){
                const hasOutgoingEdge = edges?.find((edge: any) => edge?.source === currentActiveNodeConfig?.nodeId && edge?.sourceHandle === currentActiveNodeConfig?.nodeId);
                if(hasOutgoingEdge){
                    return true;
                }
            }

            const hasTemplate = data.some((action: ChatbotStepActionData<SendWADMTemplateActionData | SendWADMTextActionData | SaveVariableActionData>) => action.action_type.action_type_name == ACTION_TYPE_NAME["TEMPLATE"]);
            const hasCarouselTemplate = data.some((action: ChatbotStepActionData<SendWADMTemplateActionData | SendWADMTextActionData | SaveVariableActionData>) => action.action_type.action_type_name == ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"]);
            const hasSendOrderDetailTemplate = data.some((action: ChatbotStepActionData<SendWADMTemplateActionData | SendWADMTextActionData | SaveVariableActionData>) => action.action_type.action_type_name == ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"]);
            if (actionTypeName == ACTION_TYPE_NAME["TEMPLATE"]) return hasCarouselTemplate || hasSendOrderDetailTemplate;
            if (actionTypeName == ACTION_TYPE_NAME["CAROUSEL_TEMPLATE"]) return hasTemplate || hasSendOrderDetailTemplate;
            if (actionTypeName == ACTION_TYPE_NAME["SEND_ORDER_DETAIL_TEMPLATE"]) return hasTemplate || hasCarouselTemplate;
        }

        return false;
    }

    const onClickOfActionBlock = (action: actionTypeObj) => {
        if (!isDisabled(action.actionType, action.maxLength)) {
            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, "", null,
                {
                    updateType: "addNewStepAction",
                    actionTypeOfNewActionBlock: action.actionType
                });

            setTimeout(() => {
                props?.bodyFormRef?.current?.scrollIntoView({ // Scroll to last added action to top.
                    behavior: "smooth",
                    block: "start"
                });
            }, 100);
        }
    }

    const shouldShowActionTypeBlock = (action: actionTypeObj) => {
        return action.allowedStepId.includes(getCurrentActiveNodeData(currentActiveNodeConfig?.nodeId, nodes)?.chatbot_step_type_id ?? chatbot_step_type_id_basic);
    }

    return (
        <>
            <Grid container direction={"column"} gap={2}>
                {actionTypes(currentActiveStaticWorkflow).map((action: actionTypeObj) => {
                    return <>
                        {shouldShowActionTypeBlock(action) &&
                            <Grid item
                                sx={{ opacity: !isDisabled(action.actionType, action.maxLength) ? "1" : "0.5", cursor: !isDisabled(action.actionType, action.maxLength) ? "pointer" : "default !important" }}
                                className={`${styles.contentBlockGlobalStyle} ${globalStyles.fullwidth}`}
                                onClick={() => onClickOfActionBlock(action)}
                            >
                                <Grid container gap={"12px"} alignItems={"center"} flexWrap={"nowrap"}>
                                    <Grid item>
                                        <IconsColor iconName={action.icon} height="27" width="27" fillColor={greyColor} />
                                    </Grid>
                                    <Grid item>
                                        <Grid container direction={"column"} gap={"2px"}>
                                            <Grid item className={styles.contentBlockHeadingStyle}>
                                                {action.title}
                                            </Grid>
                                            <Grid item className={styles.contentBlockSubHeadingStyle}>
                                                {action.description}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>}
                    </>
                })
                }
            </Grid>
        </>
    )
}

export default NewContentBlocks
